import { useCallback, useMemo } from 'react';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { useStartProgressMutation } from '../../../__generated__/chirp/com/hubspot/academy/user/progress/rpc/UserProgressWriterChirpService.hooks';
import { useGetCatalogResourcesQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.hooks';
import { CatalogShortFormContentResponseTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService';
import { GET_ALL_USER_PROGRESS_BY_USER_ID_QUERY } from '../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService.dfc.new';
import { MY_LEARNING_QUERY_FIELD_NAME } from '../myLearning/myLearningQueries';
import { GET_PLAYLIST_PROGRESS } from '../userProgress/userProgressQueries';
import { convertToSupportedLanguage } from '../../constants/academySupportedLanguages';
import { reportErrorToLogFetch } from '../../utils/errorUtils';
import { Metrics } from '../../utils/Metrics';
export const useFullShort = (shortId, skip) => {
  const {
    data,
    loading: shortLoading,
    error: shortError
  } = useGetCatalogResourcesQuery({
    skip,
    variables: {
      requestedResources: [{
        resourceId: shortId,
        type: 'SHORT_FORM_CONTENT'
      }]
    }
  });
  const short = useMemo(() => {
    var _data$results;
    if (!(data !== null && data !== void 0 && (_data$results = data.results) !== null && _data$results !== void 0 && _data$results.length)) {
      return undefined;
    }
    const result = data.results[0];
    if (result.__typename === CatalogShortFormContentResponseTypename) {
      return result;
    }
    return undefined;
  }, [data]);
  return {
    short,
    shortLoading,
    shortError
  };
};
export const useStartShort = (shortId, language, playlistId) => {
  const [startShortProgress, {
    loading: startShortLoading,
    called: startShortCalled,
    error: startShortError,
    data: startShortData
  }] = useStartProgressMutation({
    variables: {
      contentId: shortId,
      contentType: 'SHORT_FORM_CONTENT',
      language: convertToSupportedLanguage(language),
      playlistId
    },
    awaitRefetchQueries: true,
    refetchQueries: [{
      query: GET_ALL_USER_PROGRESS_BY_USER_ID_QUERY,
      variables: {
        language: convertToSupportedLanguage(language)
      },
      context: {
        timeout: 25000
      }
    }, ...(playlistId ? [{
      query: GET_PLAYLIST_PROGRESS,
      variables: {
        playlistId
      }
    }] : [])],
    onCompleted: () => {
      Metrics.counter('short-started', {
        language: readUnhandledEnumCase(convertToSupportedLanguage(language))
      }).increment();
    },
    update: (cache, result) => {
      const {
        data,
        errors
      } = result;
      if (!data || errors && errors.length) return;
      cache.evict({
        fieldName: MY_LEARNING_QUERY_FIELD_NAME
      });
    },
    onError(error) {
      Metrics.counter('short-mutation-call-error', {
        action: 'short-start-error'
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Short Start Error',
        action: 'short-start-error',
        error
      });
    }
  });
  const startShort = useCallback(() => startShortProgress(), [startShortProgress]);
  return [startShort, {
    startShortLoading,
    startShortCalled,
    startShortError,
    startShortData
  }];
};